/****************************************************************************************
 * File Name    : Factory.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
        <div class = 'div_factory'>
            <!--  -->
            <a-form :form="form" @submit="onSubmit">
                <a-card>
                    <a-form-item label="공장명">
                        <a-input placeholder="공장명" autocomplete="off" v-decorator="['factory_name',{initialValue: factory_name, rules: [{ required: false, message: '공장명을 입력하세요' }],},] "/>
                    </a-form-item>
                    <a-form-item label="주소">
                        <a-input placeholder="주소" autocomplete="off" v-decorator="['factory_address',{initialValue: factory_address, rules: [{ required: false, message: '주소를 입력하세요' }],},] "/>
                    </a-form-item>
                    <a-form-item label="대시보드 표시">
                        <a-checkbox-group v-decorator="['type',{initialValue: type, rules: [{ required: false, message: '항목을 선택하세요' }],},]" style = 'width:100%'>
                            <a-checkbox value="정수기">정수기</a-checkbox>
                            <a-checkbox value="청정기">청정기</a-checkbox>
                            <a-checkbox value="비데">비데</a-checkbox>
                        </a-checkbox-group>
                    </a-form-item>
                </a-card>
                <!--  -->
                <p/>
                <a-button type="primary" html-type="submit" :ghost = false size = "default" icon = "plus-circle">Save</a-button>
            </a-form>

  <!--  -->
        </div>
</template>
<script>
export default {
    name: 'Factory',
    components: {
    },
    data() {
        return {
            factory_name: '',
            factory_address: '',
            dashboard_item: '',
            type: [],
            isDataLoaded : false,
        };
    },
    mounted() {
        this.isDataLoaded = true;

        this.$http.get(this.$store.state.nodeApiUrl + '/product/get_system_data')
          .then((response) => {
            if (response.status === 200 && response.data.code === 'success') {
              let systemData = response.data.data.content[0];

              this.factory_name = systemData.factory_name;
              this.factory_address = systemData.factory_address;
              this.type = systemData.dashboard_item.split('||');
            }
          });
    },
    created() {
        this.form = this.$form.createForm(this, {
                onFieldsChange: (_, changedFields) => {
                    this.$emit('change', changedFields);
                },
                mapPropsToFields: () => {
                    return {
                        username: this.$form.createFormField({
                            value: this.username,
                        }),
                    };
                },
                onValuesChange: (_, values) => {
                    console.log(values);
                },
        });
    },
    methods : {

        onSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                console.log('Received values of form: ', values);
                // this.$store.commit('update', values);
                }

                this.factory_name = values.factory_name;
                this.factory_address = values.factory_address;
                this.dashboard_item = values.type.join('||');

                // 시스템 데이터 수정
                this.$http.post(this.$store.state.nodeApiUrl + '/product/save_system_data', {
                  factory_name: this.factory_name,
                  factory_address: this.factory_address,
                  dashboard_item: this.dashboard_item,
                }).then((response) => {
                  if (response.status === 200) {
                    this.$message.success('저장되었습니다');
                  }
                });
            });
        },
    }
}
</script>
<style scoped>
    .div_factory {
        text-align : left
    }
    #components-form-demo-vuex .language-bash {
        max-width: 400px;
        border-radius: 6px;
        margin-top: 24px;
    }
    .ant-form-item  {
        margin-bottom: 5px !important;
    }
    .ant-form-item-label  {
        font-weight: 700  !important;
    }

</style>